<script>
import axios from 'axios'
import vSelect from 'vue-select'
import TransformOptions from '@/mixins/TransformOptions.js'
import PhonePrefixSelect from '@/vcs/_shared/PhonePrefixSelect.vue'
import CreateOption from '@/mixins/CreateOption.js'

export default {
  name: 'UserAndPhoneSearchSelect',
  mixins: [CreateOption, TransformOptions],
  props: {
    deviceId: String,
    userOrPhone: Object,
  },
  data: function () {
    return {
      localUserOrPhone: null,
      users: [],
    }
  },
  watch: {
    userOrPhone: function (newVal) {
      if (newVal == null) {
        this.localUserOrPhone = null
      }
    },
    localUserOrPhone: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.$emit('option:selected', this.localUserOrPhone)
      }
    },
  },
  mounted() {},
  methods: {
    fetchUsers(search, loading) {
      if (search.length >= 3) {
        loading(true)
        // const instance = axios.create()
        // delete instance.defaults.headers.common['Authorization']
        // instance({
        axios({
          method: 'get',
          headers: {
            Authorization: ``,
          },
          url: `collection_points/${this.deviceId}/users`,
          params: {
            'q[query]': search,
          },
        })
          .then(response => {
            const threeFirstUsers = response.data.slice(0, 3)
            this.users = this.transformOptions(threeFirstUsers)
          })
          .catch(error => {
            this.$errorHumanized(error)
          })
          .finally(() => {
            loading(false)
          })
      } else if (search.length == 0) {
        this.users = []
      }
    },
  },
  components: { PhonePrefixSelect, vSelect },
}
</script>

<template lang="pug">
.select-with-prefix
  phone-prefix-select(@prefixSelected="onPrefixSelected($event)")
  .select-wrapper
    v-select(
      ref="phoneNumberVSelect"
      :createOption="createOptionMixinFn"
      :options="users"
      :taggable="true"
      v-model="localUserOrPhone"
      @input="$emit('userOrPhoneSelected', $event)"
      @search="fetchUsers"
      @search:focus="$emit('search:focus')"
      label="itemData"
      placeholder="Phone number"
    )
      span(slot="no-options") No search results
      template(#selected-option="{ name, email, phone, phonePrefix, itemData }")
        span(v-if="name && phone && email") {{ name }} (+{{ phonePrefix || '48' }} {{ phone }} | {{ email }})
        span(v-else-if="phone && email") +{{ phonePrefix || '48' }} {{ phone }} | {{ email }}
        span(v-else-if="name && email") {{ name }} ({{ email }})
        span(v-else-if="email") {{ email }}
        //- itemData is for `created option` - by :taggable == true
        span(v-else) {{ itemData }}

      template(#option="{ name, email, phone, phonePrefix, itemData }")
        h4.m-0
          span(v-if="name && email") {{ name }}, {{ email }}
          span(v-else-if="email") {{ email }}
          span(v-else-if="name") {{ name }}
          span(v-else-if="itemData")
            span.mr-2 {{ itemData }}
            span.mr-2.add-option-button +
            span (Choose this option)
        .text-muted.fs-1-6rem(v-if="phone") +{{ phonePrefix || '48' }} {{ phone }}
</template>

<style scoped lang="scss">
.add-option-button {
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  background: #29fc75;
  margin: 0px 10px;
  line-height: 1;
  font-size: 2rem;
}
</style>
